import { OngoingSheetService } from './ongoing-sheet.service';

export default angular
  .module('sfMobile.services.ongoingSheet', [
    'pascalprecht.translate',
    'sfMobile.services.action-sheet',
  ])
  .factory('ongoingSheet', OngoingSheetService).name;
